import { Link } from "@tanstack/react-router";
import { useAuth } from "../auth/AuthContext";

export function ScheduleTabs({ backup = false }: { backup?: boolean }) {
  const { hasRole } = useAuth();
  const base = "border-b-2 px-3 py-2 text-sm font-semibold";
  return <nav aria-label="Schedule views" className="flex gap-3 border-b border-slate-200">
    <Link to="/schedule" className={`${base} ${backup ? "border-transparent text-slate-500" : "border-blue-600 text-blue-700"}`}>Capacity</Link>
    {hasRole("owner", "gm", "sales") && <Link to="/schedule/backup" className={`${base} ${backup ? "border-blue-600 text-blue-700" : "border-transparent text-slate-500"}`}>Backup Schedule</Link>}
  </nav>;
}
